import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { FieldArray, Formik } from "formik";
import { DialogActions, InputAdornment } from "@material-ui/core";
import {
  FormTextField,
  FormArrayTextField,
  FormDateField,
  FormOutlinedNoMarginTextField,
} from "../../../../partials/content/Forms/FormField";
import { onPreventEnterSubmitting, setObject } from "../../../../utils/utils";
import { Accordion, AccordionTab } from "primereact/accordion";
import Illustration from "../../../../partials/content/Illustration";
import Swal from "sweetalert2";
import { Table } from "react-bootstrap";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchItemUom from "../../inventory/items/searchItemUom";
import SearchItem from "../../inventory/items/searchItem";
import {
  getItemPackage,
  saveItemPackage,
} from "../../../../services/sales/itemPackage";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Card, Badge } from "react-bootstrap";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
import { DateTime } from "luxon";
const ItemPackageForm = ({
  itemPackageID = 0,
  displayOnly = false,
  onCloseDialog,
  onConfirmSave,
}) => {
  const { socket, companyProfile } = useGlobalData();
  const [itemPackageData, setItemPackageData] = useState({
    ID: 0,
    packageCode: "",
    packageName: "",
    startDate: DateTime.now().startOf("day"),
    endDate: DateTime.now()
      .endOf("day")
      .plus({ days: 14 }),
    packageStatus: 0,
    packageStatusDesc: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    price: 0,
    itemPackageDetails: [],
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [openSearchItemType, setOpenSearchItemType] = useState(false);
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [itemSelected, setItemSelected] = useState(0);
  const [indexSelected, setIndexSelected] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const { auth } = store.getState();

    if (itemPackageID && itemPackageID > 0) {
      setObject(socket, "lock", itemPackageID, "ITPC", auth.user)
        .then((response) => {
          getItemPackageData(itemPackageID);
        })
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (itemPackageID && itemPackageID > 0) {
        setObject(socket, "release", itemPackageID, "ITPC", auth.user);
      }
    };
  }, [itemPackageID]);

  const itemPackageFormSchema = yup.object().shape({
    ID: yup.number(),
    packageCode: yup
      .string()
      .required("Package Code is required")
      .max(255, "Package Code maximum characters is 255"),
    packageName: yup
      .string()
      .required("Package Name is required")
      .max(255, "Package Name maximum characters is 255"),
    startDate: yup
      .date()
      .required("Start Date is required")
      .max(yup.ref("endDate"), "Start Date must be less equal to End Date"),
    endDate: yup
      .date()
      .required("End Date is required")
      .min(
        yup.ref("startDate"),
        "End Date must be greater equal to Start Date"
      ),
    price: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .required("Package Price is required")
      .min(1, "Package Price cannot be zero or empty")
      .default(0),
    itemPackageDetails: yup
      .array()
      .of(
        yup.object().shape({
          itemName: yup.string().required("Item is Required"),
          qty: yup
            .number()
            .transform((value) => (isNaN(value) ? 0 : value))
            .nullable()
            .required("Quantity is required")
            .moreThan(0, "Quantity cannot be zero or empty")
            .default(0),
          uomName: yup.string().required("Unit is Required"),
        })
      )
      .required("Package Items is required"),
  });

  return (
    <Formik
      initialValues={itemPackageData}
      validationSchema={itemPackageFormSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.price = parseFloat(values.price);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Item Package ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              const itemPackageValues = {
                ...values,
              };
              for (const packageDetail of itemPackageValues.itemPackageDetails) {
                packageDetail.qty = parseFloat(packageDetail.qty);
              }
              saveItemPackage(itemPackageValues).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div style={{ paddingBottom: "10px" }}>
                <Card>
                  <Card.Header>
                    <i className="fas fa-window-maximize"></i>
                    <span>
                      <strong>Item Package Header</strong>
                    </span>
                    {values.ID > 0 ? (
                      <React.Fragment>
                        <Badge
                          className="float-right ml-1"
                          variant={
                            values.packageStatus === 2
                              ? "danger"
                              : values.packageStatus === 1
                              ? "success"
                              : null
                          }
                        >
                          {values.packageStatus !== 0
                            ? "Package " + values.packageStatusDesc
                            : null}
                        </Badge>
                      </React.Fragment>
                    ) : null}
                  </Card.Header>
                  <Card.Body>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="row">
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            {!displayOnly ? (
                              <React.Fragment>
                                <FormTextField
                                  label="Package Code"
                                  name="packageCode"
                                  upperCase="uppercase"
                                />
                                <FormTextField
                                  label="Package Name"
                                  name="packageName"
                                />
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <FormTextField
                                  label="Package Code"
                                  name="packageCode"
                                  readonly
                                  upperCase="uppercase"
                                />
                                <FormTextField
                                  label="Package Name"
                                  name="packageName"
                                  readonly
                                />
                              </React.Fragment>
                            )}
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <div className="row">
                              <div className="col-sm-6 col-md-6 col-lg-6">
                                {!displayOnly ? (
                                  <FormDateField
                                    label="Start Date"
                                    name="startDate"
                                  />
                                ) : (
                                  <FormDateField
                                    name="startDate"
                                    label="Start Date"
                                    readonly
                                  />
                                )}
                              </div>
                              <div className="col-sm-6 col-md-6 col-lg-6">
                                {!displayOnly ? (
                                  <FormDateField
                                    label="End Date"
                                    name="endDate"
                                  />
                                ) : (
                                  <FormDateField
                                    name="endDate"
                                    label="End Date"
                                    readonly
                                  />
                                )}
                              </div>
                            </div>
                            {!displayOnly ? (
                              <FormTextField
                                label="Package Price"
                                name="price"
                                currencyField
                                currencyCode={
                                  companyProfile.currency.currencyCode
                                }
                              />
                            ) : (
                              <FormTextField
                                label="Package Price"
                                name="price"
                                readonly
                                currencyField
                                currencyCode={
                                  companyProfile.currency.currencyCode
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Package Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <FieldArray name="itemPackageDetails">
                            {({ push, remove }) => (
                              <React.Fragment>
                                <div className="row">
                                  <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="card">
                                      <Table
                                        borderless
                                        size="sm"
                                        responsive="xl"
                                      >
                                        {values.itemPackageDetails &&
                                        values.itemPackageDetails.length > 0 ? (
                                          <thead className="text-center">
                                            <tr>
                                              {!displayOnly ? (
                                                <React.Fragment>
                                                  <th style={{ width: "45%" }}>
                                                    Item Name
                                                  </th>
                                                  <th style={{ width: "25%" }}>
                                                    Quantity
                                                  </th>
                                                  <th style={{ width: "25%" }}>
                                                    Unit
                                                  </th>
                                                  <th>Actions</th>
                                                </React.Fragment>
                                              ) : (
                                                <React.Fragment>
                                                  <th style={{ width: "50%" }}>
                                                    Item Name
                                                  </th>
                                                  <th style={{ width: "25%" }}>
                                                    Quantity
                                                  </th>
                                                  <th style={{ width: "25%" }}>
                                                    Unit
                                                  </th>
                                                </React.Fragment>
                                              )}
                                            </tr>
                                          </thead>
                                        ) : null}
                                        <tbody>
                                          {values.itemPackageDetails &&
                                          values.itemPackageDetails.length >
                                            0 ? (
                                            values.itemPackageDetails.map(
                                              (item, index) => {
                                                return (
                                                  <React.Fragment key={index}>
                                                    <tr>
                                                      <td>
                                                        <FormOutlinedNoMarginTextField
                                                          value={`${item.itemCode} ${item.itemName}`}
                                                          InputProps={{
                                                            startAdornment:
                                                              item.itemType >
                                                              0 ? (
                                                                <InputAdornment position="start">
                                                                  <BootstrapTooltip
                                                                    title={
                                                                      item.itemTypeName
                                                                    }
                                                                  >
                                                                    <i
                                                                      className={
                                                                        item.itemType ===
                                                                        1
                                                                          ? "fas fa-boxes text-success"
                                                                          : item.itemType ===
                                                                            2
                                                                          ? "fas fa-tools text-primary"
                                                                          : item.itemType ===
                                                                            3
                                                                          ? "fas fa-building text-info"
                                                                          : item.itemType ===
                                                                            4
                                                                          ? "fas fa-boxes text-warning"
                                                                          : item.itemType ===
                                                                            5
                                                                          ? "fas fa-boxes text-danger"
                                                                          : null
                                                                      }
                                                                    ></i>
                                                                  </BootstrapTooltip>
                                                                </InputAdornment>
                                                              ) : null,
                                                            readOnly: true,
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        {!displayOnly ? (
                                                          <FormArrayTextField
                                                            index={index}
                                                            arrayPropName="itemPackageDetails"
                                                            propName="qty"
                                                            quantityField
                                                            margin="none"
                                                          />
                                                        ) : (
                                                          <FormArrayTextField
                                                            arrayPropName="itemPackageDetails"
                                                            index={index}
                                                            propName="qty"
                                                            margin="none"
                                                            readonly
                                                          />
                                                        )}
                                                      </td>
                                                      <td>
                                                        {!displayOnly ? (
                                                          <FormArrayTextField
                                                            index={index}
                                                            arrayPropName="itemPackageDetails"
                                                            propName="uomName"
                                                            margin="none"
                                                            searchButton
                                                            readonly
                                                            onSearchClick={() => {
                                                              setIndexSelected(
                                                                index
                                                              );
                                                              setItemSelected(
                                                                item
                                                              );
                                                              setOpenSearchUom(
                                                                true
                                                              );
                                                            }}
                                                          />
                                                        ) : (
                                                          <FormArrayTextField
                                                            arrayPropName="itemPackageDetails"
                                                            index={index}
                                                            propName="uomName"
                                                            margin="none"
                                                            readonly
                                                          />
                                                        )}
                                                      </td>
                                                      {!displayOnly ? (
                                                        <td
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          <BootstrapTooltip
                                                            title={
                                                              item.deleteInd
                                                                ? "Undo Delete"
                                                                : "Delete Package Item"
                                                            }
                                                          >
                                                            <button
                                                              type="button"
                                                              className={`btn btn-icon btn-label-${
                                                                item.deleteInd
                                                                  ? "warning"
                                                                  : "danger"
                                                              } btn-md btn-circle mx-1`}
                                                              onClick={() => {
                                                                if (
                                                                  item.ID > 0
                                                                ) {
                                                                  setFieldValue(
                                                                    "itemPackageDetails[" +
                                                                      index +
                                                                      "].deleteInd",
                                                                    !item.deleteInd
                                                                  );
                                                                } else {
                                                                  remove(index);
                                                                }
                                                              }}
                                                            >
                                                              {item.deleteInd ? (
                                                                <i className="fas fa-undo-alt"></i>
                                                              ) : (
                                                                <i className="fas fa-trash-alt"></i>
                                                              )}
                                                            </button>
                                                          </BootstrapTooltip>
                                                        </td>
                                                      ) : null}
                                                    </tr>
                                                  </React.Fragment>
                                                );
                                              }
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                className="text-center py-3"
                                                colSpan="4"
                                              >
                                                <Illustration
                                                  imageSource="INVIFO Inventory.png"
                                                  guidance="You don't have any Package items yet"
                                                  guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                                  size="sm"
                                                ></Illustration>
                                              </td>
                                            </tr>
                                          )}
                                          <tr>
                                            <td
                                              className="text-center py-3"
                                              colSpan="4"
                                            >
                                              {!displayOnly ? (
                                                <button
                                                  type="button"
                                                  className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                                  onClick={() => {
                                                    setItemSelected(0);
                                                    setOpenSearchItemType(true);
                                                  }}
                                                >
                                                  <i className="fas fa-plus-circle"></i>
                                                  Add Package Item
                                                </button>
                                              ) : null}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </Table>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            )}
                          </FieldArray>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
          <DialogLayout
            open={openSearchItemType}
            title="Select Item Type"
            onCloseDialog={() => {
              setOpenSearchItemType(false);
            }}
            maxWIdth="sm"
          >
            <div className="row menu-row-modules mt-4">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="menu-grid-square">
                  <Card
                    className="card-select-type"
                    onClick={() => {
                      setOpenSearchItemType(false);
                      setOpenSearchItem(true);
                      setTab({
                        ID: 1,
                        title: "Sellable Items",
                        icon: "fas fa-boxes",
                      });
                    }}
                  >
                    <Card.Body>
                      <div className="menu-title mb-2">Sellable Items</div>
                      <i className="fas fa-boxes fa-4x"></i>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="menu-grid-square">
                  <Card
                    className="card-select-type"
                    onClick={() => {
                      setOpenSearchItemType(false);
                      setOpenSearchItem(true);
                      setTab({
                        ID: 2,
                        title: "Services",
                        icon: "fas fa-tools",
                      });
                    }}
                  >
                    <Card.Body>
                      <div className="menu-title mb-2">Services</div>
                      <i className="fas fa-tools fa-4x"></i>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </div>
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchItemType(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchItem}
            title="Search Item"
            onCloseDialog={() => {
              setOpenSearchItem(false);
              setOpenSearchItemType(true);
            }}
            minHeight={true}
          >
            <SearchItem
              tab={tab}
              selectSellableItems={true}
              selectServiceItems={true}
              selectItemPackages={false}
              selectAssetItems={false}
              selectVariant={true}
              onSelectItem={(item, itemPackage, varCode, valueName) => {
                if (item !== null) {
                  const itemPackageDetails = [...values.itemPackageDetails];
                  itemPackageDetails.push({
                    itemID: item.ID,
                    itemType: item.itemType,
                    itemTypeName: item.itemTypeName,
                    itemCode: item.itemCode,
                    itemName: item.itemName + " " + valueName,
                    varCode: varCode,
                    qty: 0,
                    uomID: item.uomID,
                    uomName: item.itemUom.uomName,
                  });
                  setFieldValue("itemPackageDetails", itemPackageDetails);
                }
                setOpenSearchItem(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchItem(false);
                  setOpenSearchItemType(true);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchUom}
            title="Search Unit of Measurement"
            onCloseDialog={() => {
              setOpenSearchUom(false);
            }}
            maxWIdth="sm"
          >
            {itemSelected.itemID > 0 ? (
              <SearchItemUom
                itemID={itemSelected.itemID}
                onSelectUom={(uom) => {
                  setFieldValue(
                    `itemPackageDetails[${indexSelected}].uomID`,
                    uom.ID
                  );
                  setFieldValue(
                    `itemPackageDetails[${indexSelected}].uomName`,
                    uom.uomName
                  );
                  setOpenSearchUom(false);
                }}
              />
            ) : null}
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchUom(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>

          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            {!displayOnly ? (
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
                disabled={isSubmitting}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </DialogActions>
        </form>
      )}
    </Formik>
  );

  async function getItemPackageData(itemPackageID) {
    const response = await getItemPackage(itemPackageID);
    const { data } = response.data;
    setItemPackageData(data.itemPackage);
  }
};

export default ItemPackageForm;
